module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/header/component/header.component.css
// module id = ./src/app/header/component/header.component.css
// module chunks = main